<script>
import RawData from "@/components/widgets/raw-data.vue";
import LoadingTemplate from "@/components/widgets/loading-template.vue";

export default {
    name: "CollectionList",
    components: {
        RawData,
        LoadingTemplate
    },
    props: {
        collections: {
            type: Array,
            default: () => [],
        },
        loading: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: "unposted",
        },
    },
    data() {
        return {
            filter: "",
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            currentPage: 1,
        };
    },
    computed: {
        filtered(){
            let data = this.collections;
            var total = this.currentPage * this.perPage;
            if (this.filter.trim() != "" && this.filter) {
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            var currentData = data.slice(total - this.perPage, total);
            if (this.currentPage > 1 && currentData.length == 0) {
                total = (this.currentPage - 1) * this.perPage;
                currentData = data.slice(total - this.perPage, total);
            }
            return currentData;
        }
    },
    methods: {
        postCollection(x) {
            console.log(x)
            this.$emit("post", x);
        },
        voidCollection(x) {
            this.$emit("void", x);
        },
        editCollection(x) {
            this.$emit("edit", x);
        },
        deleteCollection(x) {
            this.$emit("delete", x);
        },
        printReceipt(x) {
            this.$emit("print", x);
        },
    }
}
</script>
<template>
    <div class="card">
        <div class="card-body bg-soft" :class="{'bg-warning': type == 'unposted', 'bg-success': type == 'posted', 'bg-danger': type == 'voided'}">
            <div
                class="
                    d-flex
                    justify-content-between
                    align-items-center
                    mb-3
                "
            >
                <div>
                    <h4 class="card-title mb-0">
                        {{ type == 'unposted' ? 'Unposted' : type == 'posted' ? 'Posted' : 'Voided' }} Collections
                    </h4>
                    <p class="card-title-desc mb-0">
                        List of {{ type == 'unposted' ? 'Unposted' : type == 'posted' ? 'Posted' : 'Voided' }} Collections
                    </p>
                </div>
                <div v-if="collections.length">
                    <div class="d-flex">
                        <input
                            autocomplete="off"
                            type="text"
                            v-model="filter"
                            placeholder="Search Collection..."
                            class="form-control"
                        />
                        <b-form-select
                            class="form-select ms-1 w-25"
                            v-model="perPage"
                            :options="pageOptions"
                        ></b-form-select>
                    </div>
                </div>
            </div>
            <template v-if="loading">
                <LoadingTemplate />
            </template>
            <template v-if="!loading && !collections.length">
                <h4 class="mb-0 text-center">No data found.</h4>
            </template>
            <template v-if="!loading && collections.length && filtered.length == 0">
                <h4 class="mb-0 text-center">Search not found.</h4>
            </template>
            <template v-if="!loading && collections.length">
                <div
                    role="tablist"
                    v-for="x in filtered"
                    :key="x.id"
                >
                    <b-card
                        no-body
                        class="mb-1 shadow-none"
                    >
                        <RawData :data="x" v-if="$store.state.decrypt.isAdmin()" placement="left"/>
                        <b-card-header
                            header-tag="header"
                            role="tab"
                            header-class="cursor-pointer hover-header"
                            @click="x.visible = !x.visible"
                        >
                            <div
                                class="
                                    d-flex
                                    justify-content-between
                                    align-items-center
                                "
                            >
                                <div>
                                    <div class="mb-1">
                                        <a class="text-dark hover-underline" href="javascript: void(0);">
                                            [{{ x.orNumber}}]<span v-if="!x.billingReferenceNumber">:</span> &nbsp;
                                            <span v-if="x.billingReferenceNumber">[{{x.billingReferenceNumber}}]:</span>
                                            <span>{{ x.payor }}</span>
                                        </a>
                                    </div>
                                    <h6 class="mb-0 line-height-1 text-warning" >Amount: {{formatCurrency(x.amount)}} </h6>
                                </div>
                                <div class="d-flex align-items-center">
                                    <div>
                                        <span class="d-flex align-items-center">
                                            <small v-if="!x.visible">Click here to show more details</small><i
                                                class="bx bx-chevron-right rotate font-size-18 ms-3"
                                                :class="{'rotate-90': x.visible }"
                                            ></i
                                        ></span>
                                    </div>
                                </div>
                            </div>
                        </b-card-header>
                        <b-collapse
                            :visible="x.visible"
                            :accordion="`${type}-accordion-${x.id}`"
                            role="tabpanel"
                        >
                            <b-card-body>
                                <div class="row">
                                    <div class="col-md-5 border-end">
                                        <p class="mb-2 font-size-16 font-weight-bold border-bottom">Details:</p>
                                        <div class="d-flex justify-content-between align-items-center">
                                            <h6 class="mb-0">OR Number:</h6>
                                            <span class="text-warning">{{ x.orNumber }}</span>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center">
                                            <h6 class="mb-0">Payor:</h6>
                                            <span class="text-warning">{{ x.payor }}</span>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center">
                                            <h6 class="mb-0">Particulars:</h6>
                                            <span class="text-warning">{{ x.particular }}</span>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center">
                                            <h6 class="mb-0">Fund Source:</h6>
                                            <span class="text-warning">{{ x.fundSource }}</span>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center">
                                            <h6 class="mb-0">Payment Mode:</h6>
                                            <span class="text-warning">{{ x.mode }}</span>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center">
                                            <h6 class="mb-0">Amount:</h6>
                                            <span class="text-warning">{{ formatCurrency(x.amount) }}</span>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center">
                                            <h6 class="mb-0">Created By:</h6>
                                            <span class="text-warning">{{ x.createdByUser }}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-7">
                                        <p class="mb-2 font-size-16 font-weight-bold border-bottom">Collection Items:</p>
                                        <table class="table table-bordered table-striped">
                                            <thead>
                                                <tr>
                                                    <th class="py-2">Fee</th>
                                                    <th class="py-2 text-center" style="width:170px;">Amount</th>
                                                    <th class="py-2">Remarks</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="y in x.collectionItems" :key="y.id">
                                                    <td class="py-1">{{ y.fee }}</td>
                                                    <td class="py-1 text-right">{{ y.amount ? formatCurrency(y.amount) : '-' }}</td>
                                                    <td class="py-1">{{ y.remarks }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <hr>
                                <div class="text-right">
                                    
                                    <button class="btn btn-outline-success btn-rounded me-1" v-if="type == 'unposted'" @click="editCollection(x)"><i class="bx bx-edit" ></i> Update</button>
                                    <button class="btn btn-outline-danger btn-rounded me-1"  v-if="type == 'unposted'" @click="deleteCollection(x)"><i class="bx bx-trash"></i> Remove</button>
                                    <button class="btn btn-outline-purple btn-rounded me-1"  @click="printReceipt(x)"><i class="bx bx-receipt"></i> Print Receipt</button>
                                    <button class="btn btn-success me-1" v-if="type == 'unposted'" @click="postCollection(x)"><i class="bx bx-right-arrow" ></i> Post Collection</button>
                                    <button class="btn btn-danger" v-if="type == 'unposted'" @click="voidCollection(x)"><i class="bx bx-x"></i> Void Collection</button>
                                </div>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </div>
            </template>
        </div>
    </div>
</template>